import { React } from 'react'
import { useTranslation } from 'react-i18next'
import InputField from 'reusableComponents/InputField/InputField'
import styled from 'styled-components'
import { PropTypes } from 'prop-types'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
  width: 100%;
`

const DeliveryInstructions = ({ onValueChangeHandler, instructions, inputCount }) => {
  const { t } = useTranslation(['translation'])

  return (
    <Container>
      <InputField
        id="additional-delivery-instructions"
        inputCount={inputCount}
        onChange={onValueChangeHandler}
        value={instructions}
        maxLength={150}
        label={t('deliveryPreferencesSummary.instruction_type')}
        as="textarea"
        rows={7}
        inputWidth="100%"
        style={{ minHeight: '200px', width: '100%' }}
      />
    </Container>
  )
}

DeliveryInstructions.propTypes = {
  onValueChangeHandler: PropTypes.func,
  instructions: PropTypes.string,
  inputCount: PropTypes.number,
}

DeliveryInstructions.defaultProps = {
  onValueChangeHandler: null,
  instructions: '',
  inputCount: 0,
}

export default DeliveryInstructions
